module.exports = __webpack_public_path__ + "static/img/donload.baa9e4f9.png";